<template>
    <div class="site-chrome">
        <a class="skip-link" href="#main">{{ translateWord('Pular para o conteúdo') }}</a>
        <div v-if="overlay" class="mm-overlay" aria-hidden="true" @click="closeAll"></div>
        <header
            ref="head"
            :class="{ 'is-docked': docked, 'hf-hide': hidden, 'is-mm-open': overlay }"
        >
            <nav ref="nav" class="nav" :class="{ 'is-mnav-open': drawer }" :aria-label="translateWord('Principal')">
                <a class="brand" :href="href(homeLink)" :aria-label="translateWord('Página inicial da Builderall')">
                    <img :src="logo" alt="Builderall" width="103" height="26">
                </a>

                <ul class="nav-links" id="navLinks">
                    <li
                        v-for="mega in megas"
                        :key="mega.id"
                        class="nav-item has-mega"
                        :class="{ 'is-open': openId === mega.id }"
                        :data-menu="mega.id"
                        @mouseenter="onEnter(mega.id)"
                        @mouseleave="onLeave"
                        @focusout="onFocusOut(mega.id)"
                        @keydown="onItemKey(mega.id, $event)"
                    >
                        <button
                            class="nav-trigger"
                            type="button"
                            :aria-expanded="openId === mega.id ? 'true' : 'false'"
                            :aria-controls="'mm-' + mega.id"
                            aria-haspopup="true"
                            @click="onTriggerClick(mega.id, $event)"
                            @keydown="onTriggerKey(mega.id, $event)"
                        >
                            <span>{{ label(mega) }}</span>
                            <svg class="chev" width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </button>
                        <div class="mm-panel" :id="'mm-' + mega.id">
                            <div class="mm-inner">
                                <div class="mm-main">
                                    <div class="mm-groups" :class="mega.groupsClass">
                                        <div v-for="group in mega.groups" :key="group.id" class="mm-group">
                                            <p class="mm-label" :id="group.id">{{ label(group) }}</p>
                                            <ul class="mm-list" :aria-labelledby="group.id">
                                                <li v-for="(entry, index) in group.items" :key="group.id + '-' + index">
                                                    <a class="mm-link" :href="href(entry)" @click="onNavLink">
                                                        <span class="mm-ico" :class="{ peach: entry.peach }" aria-hidden="true" v-html="iconSvg(entry)"></span>
                                                        <span class="mm-txt">
                                                            <span class="mm-name">{{ label(entry) }}</span>
                                                            <span class="mm-desc">{{ label(entry, 'desc') }}</span>
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="mm-foot">
                                        <a class="mm-all" :href="href(mega.foot)" @click="onNavLink">
                                            <span>{{ label(mega.foot) }}</span>
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
                                        </a>
                                    </div>
                                </div>
                                <aside class="mm-promo" :class="{ peach: mega.promo.peach }">
                                    <span class="mm-pill">{{ mega.promo.pillLiteral ? mega.promo.pill : translateWord(mega.promo.pill) }}</span>
                                    <h3 class="mm-promo-title">{{ translateWord(mega.promo.title) }}</h3>
                                    <p class="mm-promo-desc">{{ translateWord(mega.promo.desc) }}</p>
                                    <MegaPromoArt :name="mega.promo.art" />
                                    <a class="btn mm-cta" :href="href(mega.promo)" @click="onNavLink">
                                        <span>{{ translateWord(mega.promo.cta) }}</span>
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
                                    </a>
                                </aside>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item is-current">
                        <a :href="href(pricingLink)" aria-current="page" class="is-current" @click="onNavLink">{{ translateWord('Preços') }}</a>
                    </li>
                    <li class="mnav-actions">
                        <a class="login" :href="href(loginLink)" @click="onNavLink">
                            <span>{{ translateWord('Login') }}</span>
                            <svg width="13" height="13" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M6.5 13.5 13.5 6.5M7.5 6.5h6v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </a>
                    </li>
                </ul>

                <div class="nav-right">
                    <button class="btn btn-sm" type="button" @click="scrollToPlans">
                        {{ translateWord('Começar') }}<span v-if="trial" class="btn-tail"> {{ translateWord('Grátis') }}</span>
                    </button>
                    <a class="login" :href="href(loginLink)" @click="onNavLink">
                        <span>{{ translateWord('Login') }}</span>
                        <svg width="13" height="13" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M6.5 13.5 13.5 6.5M7.5 6.5h6v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </a>
                    <button
                        class="nav-toggle"
                        type="button"
                        :aria-label="drawer ? translateWord('Fechar menu') : translateWord('Abrir menu')"
                        :aria-expanded="drawer ? 'true' : 'false'"
                        aria-controls="navLinks"
                        @click="toggleDrawer"
                    >
                        <svg class="ico-open" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 6h14M3 10h14M3 14h14" stroke="#323232" stroke-width="1.6" stroke-linecap="round"/></svg>
                        <svg class="ico-close" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5 5 15" stroke="#323232" stroke-width="1.6" stroke-linecap="round"/></svg>
                    </button>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { megas, resolveHref } from './site-chrome/nav';
import MegaPromoArt from './MegaPromoArt';

const homeLink = { linkKey: 'home' };
const loginLink = { linkKey: 'login' };
const pricingLink = { self: true };

export default {
    name: 'SiteHeader',
    components: { MegaPromoArt },
    props: {
        trial: { type: Boolean, default: false }
    },
    data() {
        return {
            megas,
            homeLink,
            loginLink,
            pricingLink,
            logo: require('../../assets/images/logo-horizontal.svg'),
            openId: null,
            drawer: false,
            docked: false,
            hidden: false
        };
    },
    computed: {
        ...mapGetters(['translateWord', 'getAllParamsUrl', 'linksPage']),
        links() {
            return this.linksPage('plans');
        },
        overlay() {
            return this.drawer || (!!this.openId && this.desktop && this.desktop.matches);
        }
    },
    mounted() {
        this.desktop = window.matchMedia('(min-width:901px)');
        this.hoverable = window.matchMedia('(hover:hover) and (pointer:fine)');
        this.still = window.matchMedia('(prefers-reduced-motion:reduce)');
        this._lastY = window.pageYOffset || 0;
        this._pins = [];
        this._timer = null;
        this._intent = null;
        this._queued = false;
        this._raf = null;
        this._rescan = null;

        this._onScroll = () => {
            if (this._queued) return;
            this._queued = true;
            this._raf = requestAnimationFrame(() => this.frame());
        };
        this._onResize = () => {
            clearTimeout(this._rescan);
            this._rescan = setTimeout(() => {
                this.collectPins();
                this.frame();
            }, 150);
        };
        this._onFocusIn = () => {
            this.hidden = false;
        };
        this._onDocClick = (event) => {
            if (this.$refs.nav && this.$refs.nav.contains(event.target)) return;
            this.closeAll();
        };
        this._onKey = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                if (this.openId) {
                    const id = this.openId;
                    this.closePanel();
                    const btn = this.itemEl(id) && this.itemEl(id).querySelector('.nav-trigger');
                    if (btn) btn.focus();
                }
                if (this.drawer) {
                    this.closeDrawer();
                    const toggle = this.$el.querySelector('.nav-toggle');
                    if (toggle) toggle.focus();
                }
                return;
            }
            if (event.key !== 'Tab' || !this.drawer) return;
            const nav = this.$refs.nav;
            if (!nav) return;
            const can = [].slice.call(nav.querySelectorAll('a[href],button:not([disabled])')).filter((el) => el.offsetParent !== null);
            if (!can.length) return;
            const first = can[0];
            const last = can[can.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        };
        this._onDesktop = () => this.resetMenus();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
        this.$refs.head.addEventListener('focusin', this._onFocusIn);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);
        if (this.desktop.addEventListener) this.desktop.addEventListener('change', this._onDesktop);
        else this.desktop.addListener(this._onDesktop);

        document.documentElement.classList.add('hf-page');
        this.collectPins();
        this.$nextTick(() => {
            this.collectPins();
            this.frame();
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        if (this.$refs.head) this.$refs.head.removeEventListener('focusin', this._onFocusIn);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        if (this.desktop) {
            if (this.desktop.removeEventListener) this.desktop.removeEventListener('change', this._onDesktop);
            else this.desktop.removeListener(this._onDesktop);
        }
        clearTimeout(this._timer);
        clearTimeout(this._intent);
        clearTimeout(this._rescan);
        if (this._raf) cancelAnimationFrame(this._raf);
        this.lock(false);
        document.documentElement.classList.remove('hf-page');
    },
    methods: {
        label(entry, field) {
            const key = field ? entry[field] : entry.label || entry.name;
            if (!field && entry.literal) return entry.name;
            if (!key) return '';
            return this.translateWord(key);
        },
        href(entry) {
            return resolveHref(entry, this.links, this.queryParams(), this.$route.path);
        },
        queryParams() {
            const raw = this.getAllParamsUrl(false) || '';
            const search = new URLSearchParams(raw.charAt(0) === '?' ? raw.slice(1) : raw);
            search.delete('period');
            const q = search.toString();
            return q ? `?${q}` : '';
        },
        iconSvg(entry) {
            return '<svg viewBox="0 0 24 24" aria-hidden="true">' + entry.icon + '</svg>';
        },
        itemEl(id) {
            return this.$el.querySelector('[data-menu="' + id + '"]');
        },
        triggers() {
            return [].slice.call(this.$el.querySelectorAll('.nav-item.has-mega .nav-trigger'));
        },
        panelLinks(id) {
            const item = this.itemEl(id);
            return item ? [].slice.call(item.querySelectorAll('.mm-panel a')) : [];
        },
        openPanel(id) {
            this.stopIntent();
            clearTimeout(this._timer);
            this._timer = null;
            if (this.openId === id) return;
            this.openId = id;
            if (this.desktop.matches) this.hidden = false;
        },
        closePanel() {
            this.stopIntent();
            clearTimeout(this._timer);
            this._timer = null;
            this.openId = null;
        },
        closeSoon() {
            clearTimeout(this._timer);
            this._timer = setTimeout(() => {
                this._timer = null;
                this.closePanel();
            }, 150);
        },
        stopIntent() {
            if (this._intent) {
                clearTimeout(this._intent);
                this._intent = null;
            }
        },
        hoverOpen(id) {
            clearTimeout(this._timer);
            this._timer = null;
            if (this.openId) {
                this.openPanel(id);
                return;
            }
            this.stopIntent();
            this._intent = setTimeout(() => {
                this._intent = null;
                this.openPanel(id);
            }, 110);
        },
        onEnter(id) {
            if (this.desktop.matches && this.hoverable.matches) this.hoverOpen(id);
        },
        onLeave() {
            this.stopIntent();
            if (this.desktop.matches && this.hoverable.matches) this.closeSoon();
        },
        onTriggerClick(id, event) {
            const fromKey = event.detail === 0;
            if (this.openId === id && (fromKey || !this.hoverable.matches || !this.desktop.matches)) this.closePanel();
            else this.openPanel(id);
        },
        onTriggerKey(id, event) {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.focusTrigger(1, event.target);
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.focusTrigger(-1, event.target);
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                this.openPanel(id);
                this.$nextTick(() => this.focusInPanel(id, 'first'));
            } else if (event.key === 'ArrowUp' && this.openId === id) {
                event.preventDefault();
                this.$nextTick(() => this.focusInPanel(id, 'last'));
            }
        },
        onItemKey(id, event) {
            if (event.key !== 'ArrowUp') return;
            const btn = this.itemEl(id).querySelector('.nav-trigger');
            if (event.target === btn) return;
            if (this.panelLinks(id).indexOf(event.target) === 0) {
                event.preventDefault();
                btn.focus();
            }
        },
        onFocusOut(id) {
            if (!this.desktop.matches) return;
            setTimeout(() => {
                const item = this.itemEl(id);
                if (this.openId === id && item && !item.contains(document.activeElement)) this.closePanel();
            }, 0);
        },
        focusTrigger(step, from) {
            const all = this.triggers();
            const at = all.indexOf(from);
            if (at < 0) return;
            const next = all[(at + step + all.length) % all.length];
            if (next) next.focus();
        },
        focusInPanel(id, which) {
            const links = this.panelLinks(id);
            const target = which === 'last' ? links[links.length - 1] : links[0];
            if (!target) return;
            let left = 12;
            const attempt = () => {
                target.focus();
                if (document.activeElement === target || left-- <= 0) return;
                requestAnimationFrame(attempt);
            };
            attempt();
        },
        toggleDrawer() {
            if (this.drawer) this.closeDrawer();
            else this.openDrawer();
        },
        openDrawer() {
            this.drawer = true;
            this.lock(true);
            this.hidden = false;
        },
        closeDrawer() {
            this.drawer = false;
            this.lock(false);
            this.closePanel();
        },
        closeAll() {
            this.closePanel();
            if (this.drawer) this.closeDrawer();
        },
        resetMenus() {
            this.closePanel();
            if (this.drawer) this.closeDrawer();
        },
        onNavLink() {
            this.closeAll();
        },
        scrollToPlans() {
            const grid = document.getElementById('plans-grid');
            if (!grid) return;
            const head = this.$refs.head;
            const reduce = this.still && this.still.matches;
            const top = grid.getBoundingClientRect().top + (window.pageYOffset || 0) - (head ? head.offsetHeight : 0);
            window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
            this.closeAll();
        },
        lock(on) {
            const root = document.documentElement;
            const body = document.body;
            if (on) {
                const gutter = window.innerWidth - root.clientWidth;
                root.style.setProperty('--hf-sbw', (gutter > 0 ? gutter : 0) + 'px');
                root.classList.add('hf-lock', 'mnav-lock');
                body.classList.add('hf-lock', 'mnav-lock');
            } else {
                root.classList.remove('hf-lock', 'mnav-lock');
                body.classList.remove('hf-lock', 'mnav-lock');
                root.style.removeProperty('--hf-sbw');
            }
        },
        collectPins() {
            const page = this.$el.closest('.pricing-page');
            this._pins = page ? [].slice.call(page.querySelectorAll('[data-hf-pin]')) : [];
        },
        pinned() {
            const pins = this._pins || [];
            for (let i = 0; i < pins.length; i++) {
                const el = pins[i];
                const rect = el.getBoundingClientRect();
                if (!rect.height) continue;
                const stickyTop = parseFloat(window.getComputedStyle(el).top);
                const top = isFinite(stickyTop) ? stickyTop : 0;
                const parent = el.parentElement;
                if (!parent) continue;
                const parentBottom = parent.getBoundingClientRect().bottom;
                if (rect.top <= top + 1 && parentBottom > el.offsetHeight + 40 && rect.bottom > top + 1) return true;
            }
            return false;
        },
        frame() {
            this._queued = false;
            const head = this.$refs.head;
            if (!head) return;
            const y = window.pageYOffset || 0;
            const min = head.offsetHeight + 40;
            this.docked = y > min;
            const focused = head.contains(document.activeElement);
            if (y <= min || this.openId || this.drawer || focused) {
                this.hidden = false;
            } else if (this._pins.length && this.pinned()) {
                this.hidden = true;
            } else if (!this.still.matches) {
                if (y > this._lastY + 6) this.hidden = true;
                else if (y < this._lastY - 6) this.hidden = false;
            }
            this._lastY = y;
        }
    }
};
</script>
